"use strict";

import Swiper from 'swiper';

export function initInScope ($scope) {
    $scope.find('.js-swiper-image-thumb').each(function (index, value) {
        let $swiperContainer = $(this),
            $swiperMain = $swiperContainer.find('.js-swiper-image-thumb-main'),
            $swiperNav = $swiperContainer.find('.js-swiper-image-thumb-nav'),
            $swiperArrowContainerMain = $swiperMain.closest('.js-swiper-arrow-container');

        let swiperNav = new Swiper ($swiperNav, {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 20,
            keyboard: {
                enabled: true,
            }
        });

        new Swiper ($swiperMain, {
            loop: false,
            slidesPerView: 1,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: $swiperArrowContainerMain.find('.js-swiper__next'),
                prevEl: $swiperArrowContainerMain.find('.js-swiper__prev'),
            },
            thumbs: {
                swiper: swiperNav
            }

        });

    });
    

}